import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

//import {Scorpio} from "./Scorpio";

export class TOABackgroundIdleView extends BaseView {
    private _dust: TimelineSprite;
    /*private _scorpioLeft: Scorpio;
    private _scorpioRight: Scorpio;*/

    constructor() {
        super();
    }

    playDustAnimation() {
        this._dust.getAnimationAutoShowHide(true, true);
    }

    /*public playScorpioAnim() {
        if (NolimitApplication.isLandscape) {
            const tl = this._scorpioRight.play();
            tl?.add(() => {
                this._scorpioLeft.play();
            });
            //this._scorpioLeft.play();
            //this._scorpioRight.play();
        }
    }*/

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.BACKGROUND_IDLE.name).addChild(this);
        //StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REEL_FOREGROUND.name).addChild(this);
        const dust = new TimelineSprite(GameResources.getTextures("dust"));

        dust.blendMode = PIXI.BLEND_MODES.ADD;
        dust.anchor.set(0.5);
        dust.scale.set(5); //#244
        dust.position.set(360, 0);
        dust.visible = false;
        this._dust = dust;
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REEL_FOREGROUND.name).addChild(this._dust);
        //this.createScorpio();
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.PORTRAIT) {
            this._dust.y = 800; //#244
            //this._scorpioRight?.onPortrait();
            //this._scorpioLeft?.onPortrait();
        } else {
            this._dust.y = 480;
        }
    }

    /*private createScorpio() {
        this._scorpioLeft = new Scorpio(true);
        this._scorpioRight = new Scorpio(false);
        this.addChild(this._scorpioLeft, this._scorpioRight);
    }*/
}